import { useForm } from 'react-hook-form';
import { Modal, ModalBody, ModalHeader, Col, Row, ModalFooter, Form } from 'reactstrap';
import Button, { ButtonSizes, ButtonVariants } from '@/components/Button/Button';
import FormInput from '@/components/forms/FormInput';
import { DEPOSIT_STATUSES, SUPPORTED_CHAINS } from '../deposits-query-reducer';
import { DepositsFilterDto } from '@/services/deposits/deposits-types';

interface DepositsFilterFormProps {
  onClose: () => void;
  onApplyFilters: (filters: DepositsFilterDto) => void;
  currentFilters: DepositsFilterDto;
}

const DepositsFilterForm: React.FC<DepositsFilterFormProps> = ({ onClose, onApplyFilters, currentFilters }) => {
  const { control, handleSubmit } = useForm({
    defaultValues: currentFilters,
  });

  const onSubmit = (data: DepositsFilterDto) => {
    // Remove any undefined or empty string values
    const cleanedFilters = Object.entries(data).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== '') {
        acc[key] = value;
      }
      return acc;
    }, {} as DepositsFilterDto);

    onApplyFilters(cleanedFilters);
  };

  return (
    <Modal centered isOpen>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <ModalHeader toggle={onClose} className="d-flex justify-content-between align-items-center w-full">
            Filters
          </ModalHeader>
        </div>
        <ModalBody>
          <Row>
            <Col>
              <FormInput
                label="Status"
                name="status"
                control={control}
                type="select"
                options={[
                  { label: 'All Statuses', value: '' },
                  ...DEPOSIT_STATUSES.map((status) => ({
                    label: status,
                    value: status,
                  })),
                ]}
              />
            </Col>
            <Col>
              <FormInput
                label="Chain"
                name="chain"
                control={control}
                type="select"
                options={[
                  { label: 'All Chains', value: '' },
                  ...SUPPORTED_CHAINS.map((chain) => ({
                    label: chain.charAt(0).toUpperCase() + chain.slice(1),
                    value: chain,
                  })),
                ]}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-outline"
            variant={ButtonVariants.secondary}
            size={ButtonSizes.sm}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="btn btn-primary"
            variant={ButtonVariants.primary}
            size={ButtonSizes.sm}
            onClick={handleSubmit(onSubmit)}
          >
            Apply Filter
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default DepositsFilterForm;
